var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCamera({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "612px",
    height: "612px",
    viewBox: "0 0 612 612",
    style: {
      enableBackground: "new 0 0 612 612"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 472.909,
    cy: 222.545,
    r: 27.818
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.733,125.181c3.422,0,6.176-2.476,6.176-5.563v-16.691c0-3.06-2.754-5.563-6.176-5.563h-43.285 c-3.421,0-6.175,2.476-6.175,5.563v16.691c0,3.06,2.754,5.563,6.175,5.563H160.733z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.909,445.091c69.128,0,125.182-56.055,125.182-125.182c0-69.129-56.054-125.183-125.182-125.183 c-69.128,0-125.182,56.054-125.182,125.183C194.727,389.036,250.781,445.091,319.909,445.091z M319.909,222.545 c53.772,0,97.363,43.591,97.363,97.364c0,53.771-43.591,97.363-97.363,97.363s-97.364-43.592-97.364-97.363 C222.545,266.136,266.137,222.545,319.909,222.545z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,194.727v278.183c0,55.637,55.636,55.637,55.636,55.637h500.727c0,0,55.637,0,55.637-55.637V194.727 c0-55.636-55.637-55.636-55.637-55.636H450.654l-29.543-49.21c-2.114-3.561-7.232-6.426-11.238-6.426H229.945 c-4.089,0-9.18,2.977-11.239,6.426l-29.543,49.21H55.636C55.636,139.09,0,139.09,0,194.727z M207.913,166.909l30.989-55.637 h159.343l35.245,55.637h122.567c0,0,28.124,0,28.124,28.319V472.38c0,28.348-28.124,28.348-28.124,28.348H55.942 c0,0-28.124,0-28.124-28.348V195.228c0-28.319,28.124-28.319,28.124-28.319H207.913z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.982274d8.svg";
export { ForwardRef as ReactComponent };